<template>
  <div class="login_wrap">
    <div>
      <img :src="logo" alt="logo" class="logo" />
      <div class="title_wrap">
        <!-- <div class="title">{{ language("login.title") }}</div> -->
        <div class="subTitle">{{ language("login.subTitle") }}</div>
      </div>

      <div class="login_form">
        <el-card>
          <el-tabs v-model="activeName" :stretch="true" @tab-click="change">
            <el-tab-pane label="账号登录" name="0"></el-tab-pane>
            <el-tab-pane label="扫码登录" name="1"></el-tab-pane>
          </el-tabs>

          <div class="tab1" v-show="activeName == '0'">
            <el-form
              :model="form"
              status-icon
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
              label-position="left"
            >
              <el-form-item prop="username">
                <el-input
                  v-model="form.username"
                  @keyup.enter.native="submitForm('ruleForm')"
                  :placeholder="language('login.loginName')"
                  prefix-icon="el-icon-user-solid"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="form.password"
                  type="password"
                  autocomplete="off"
                  @keyup.enter.native="submitForm('ruleForm')"
                  :placeholder="language('login.password')"
                  prefix-icon="el-icon-lock"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('ruleForm')"
                  class="login_button"
                  >{{ language("login.submit") }}</el-button
                >
                <div>
                  <el-checkbox v-model="checked">{{
                    language("login.remember")
                  }}</el-checkbox>
                </div>
              </el-form-item>
            </el-form>
          </div>

          <div class="tab2" v-show="activeName == '1'">
            <i class="el-icon-full-screen" style="screen"></i>
            <div class="ol">
              <ol>
                <li>出示您的账号二维码/一维码</li>
                <li>对准电脑外接扫描仪</li>
                <li>成功识别登入</li>
              </ol>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
// import Cookies from "vue-cookies";
export default {
  data() {
    return {
      logo: require("../../assets/logo.png"),
      activeName: "0",
      loading: false,
      form: {
        // password: "676HmmJT",
        // username: "deadline_0122@163.com",
      },
      rules: {
        username: [
          {
            required: true,
            message: "",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "",
            trigger: "change",
          },
        ],
      },
      checked: false,
      code: "",
      login: false,
    };
  },
  watch: {
    activeName: {
      handler() {},
      deep: true,
      immediate: true,
    },
  },
  methods: {
    change() {
      localStorage.setItem("index", this.activeName);
    },
    random() {
      let code = [
        "Q",
        "W",
        "E",
        "T",
        "Y",
        "U",
        "I",
        "O",
        "P",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
      ];
      var num = "";
      for (var i = 0; i < 5; i++) {
        num += code[Math.floor(Math.random() * 19)];
      }
      return num;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.remember = this.checked ? "on" : "off";
          this.ccRequest
            .do("loginJson", this.form)
            .then((res) => {
              this.ccRequest
                .do("mgr/get", {})
                .then((res) => {
                  // console.log(res);
                  if (res.roleid == "") {
                    this.$message.error("请设置账号角色再登录");
                    return false;
                  }
                  if (res.isFirstLogin == 1) {
                    this.$alert("请先重置密码再登录", "密码重置提醒", {
                      confirmButtonText: "去重置",
                      type: "warning",
                      callback: (action) => {
                        console.log(action);
                        if (action == "confirm") {
                          this.$router.push({
                            path: "/admin/sys/reset",
                          });
                        }
                      },
                    });
                  } else {
                    this.$message.success("登录成功");
                    //記住密碼
                    if (this.checked) {
                      // let data = window.btoa(
                      //   window.btoa(JSON.stringify(this.form))
                      // );
                      let data = JSON.stringify(this.form);
                      localStorage.setItem(
                        process.env.VUE_APP_logoKey,
                        this.random() + data
                      );
                    } else {
                      localStorage.removeItem(process.env.VUE_APP_logoKey);
                    }
                    this.loading = false;
                    this.getUserData();
                  }
                })
                .catch((err) => {
                  this.loading = false;
                  this.$message.error(err.response.data.message);
                });
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err.response.data.message);
            });
        } else {
          return false;
        }
      });
    },
    getUserData() {
      // window.location.href = process.env.VUE_APP_home;
      window.location.href = window.location.origin;
    },
    autoLogin(e) {
      if (this.activeName == 1) {
        console.log(e);
        if (e.code) {
          if (e.code == "Enter") {
            this.codeLogin(this.code);
          } else {
            this.code += e.key;
          }
        } else {
          this.codeLogin(e);
        }
      }
    },
    codeLogin(e) {
      this.login = true;
      this.ccRequest
        .do("admin/fsb/employeeinfo/scanQrCodeLogin", { encrypt: e })
        .then((res) => {
          this.$message.success("登录成功");
          this.code = "";
          setTimeout(() => {
            // window.location.href = process.env.VUE_APP_home;
            window.location.href = window.location.origin;
          }, 1000);
        })
        .catch((err) => {
          this.login = false;
          this.code = "";
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    if (window.parent.document.getElementById("page-wrapper")) {
      // top.location.href = process.env.VUE_APP_home;
      top.location.href = window.location.origin;
    }
    let that = this;
    document.onkeypress = function (e) {
      if (that.login) {
      } else {
        that.autoLogin(e);
      }
    };
    if (localStorage.getItem(process.env.VUE_APP_logoKey)) {
      try {
        let data = JSON.parse(
          // window.atob(
          //   window.atob(
          localStorage.getItem(process.env.VUE_APP_logoKey).substring(5)
          //   )
          // )
        );
        this.form = { ...data };
        this.checked = true;
      } catch (error) {}
    }
    try {
      this.activeName = localStorage.getItem("index") || "0";
    } catch (error) {}
  },
};
</script>
<style lang="scss">
.login_wrap {
  //   .el-form-item__label {
  //     font-weight: 600;
  //   }
  .el-tabs__item {
    color: #aaa9a9;
  }
  .is-active {
    color: #000 !important;
  }
  .el-tabs__active-bar {
    background-color: #000 !important;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000 !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #000 !important;
    border-color: #000 !important;
  }
}
</style>
<style scoped lang="scss">
.login_wrap {
  //   height: 100vh;
  display: flex;
  //   align-items: center;
  justify-content: center;

  // padding-top: 150px;
  padding-top: 100px;
  box-sizing: border-box;
}
.title_wrap {
  padding: 0 0 20px 0;
  margin: 10px auto 0 auto;
  //   color: $mainColor;
  font-weight: 600;
  width: 620px;
  div {
    text-align: center;
  }
  .title {
    font-size: 36px;
    margin-bottom: 10px;
    color: #878787;
  }
  .subTitle {
    font-size: 20px;
  }
}
.logo {
  width: 300px;
  margin: 0 auto;
  display: block;
}
.login_form {
  //   : 50px auto 0 auto;
  margin: 0 auto;
  width: 500px;
}
.tab1 {
  padding: 20px 20px;
}
.login_button {
  width: 100%;
  background: #000;
  border-color: #000 !important;
}
.tab2 {
  padding: 20px 20px 40px 20px;

  display: flex;
  justify-content: center;
}
.el-icon-full-screen:before {
  font-size: 100px;
}

.ol {
  display: flex;
  align-items: center;
  margin-left: 40px;
  font-weight: 700;
  li {
    margin-bottom: 5px;
  }
}
</style>